export const BoxSizeItem = {
  Icon: {
    icon: 'gap',
    color: 'inactive',
    boxSize: 'A1 A1'
  },
  SizeUnits: {
    flow: 'column-reverse',
    LetterValue: {
      // Was fixed 'white' — this row renders on BoxSizeRow's adaptive
      // `document-background`, so a fixed literal went invisible in light.
      color: 'title',
      fontSize: 'A1',
      padding: 'X2 X2 0 X2'
    },
    NumberValue: {
      color: 'inactive',
      fontSize: 'Y',
      padding: 'X X2 X2 X2'
    }
  },
  Span: {
    title: 'paragraph',
    text: '{{ editor.boxSize.min | polyglot }}',
    fontSize: 'Y',
    alignSelf: 'flex-end',
    margin: '- - -Y -'
  },
  flow: 'x',
  padding: 'Z Y1',
  gap: 'C',
  margin: '-1px'
}
